// utils/checkboxState.ts
import { BranchLocation, Location } from '../types';
import normalizeLocationId from './normalizeLocationId';
import { isBranch } from './validations';

const hasSelectedDescendants = (
  branch: BranchLocation,
  selectedLocations: Location[]
): boolean => {
  const selectedIds = new Set(
    selectedLocations.map((loc) => normalizeLocationId(loc.id))
  );

  const checkDescendants = (node: Location): boolean => {
    if (selectedIds.has(normalizeLocationId(node.id))) return true;

    if (isBranch(node) && node.children.length > 0) {
      return node.children.some(checkDescendants);
    }

    return false;
  };

  return branch.children.some(checkDescendants);
};

export default hasSelectedDescendants;
